import { Component, OnInit, ElementRef, ViewChild, Directive } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { DataserviceComponent } from './../shared/dataservice/dataservice.component'
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable, Timestamp } from 'rxjs/Rx'
import { FetchdataServiceService } from '../fetchdata-service.service';
import { CaseDetails, Case, AttachmentsDetails, ArrAttachmentsDetails, Results } from '../case-details';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-existing-case',
  templateUrl: './existing-case.component.html',
  styleUrls: ['./existing-case.component.css']
})
export class ExistingCaseComponent implements OnInit {
  myForm1: FormGroup;
  myForm2: FormGroup;

  loc: string = 'en';
  enTemplate: Boolean = true;

  showPage1: Boolean = true;
  showPage2: Boolean;
  showPage3: Boolean;
  ShowSpinner: Boolean = false;
  caseDetails: CaseDetails;
  private arrAttachments: ArrAttachmentsDetails[];

  mode = 'indeterminate';
  //Url = "https://localhost:44354/api/Contactus"
  Url = "https://contactusapi.kia.ca/api/Contactus"
  //Url = "https://contactusapiuat.kia.ca/api/Contactus"

  constructor(private route: ActivatedRoute, public dataservice: DataserviceComponent, private fb: FormBuilder, private srv: FetchdataServiceService, private cookieService: CookieService) { }

  ngOnInit() {
    this.loc = this.route.snapshot.queryParamMap.get('loc');

    if (this.loc != null) {
      if (this.loc == 'fr')
        this.enTemplate = false;
      else
        this.enTemplate = true;
    } else {

      if (this.cookieService.get('lang') == 'fr')
        this.enTemplate = false;
      else
        this.enTemplate = true;

    }

   

    this.myForm1 = this.fb.group({
      caseNumber: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      lastName: ['', [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
      email: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$')]],


    });

    //here if the case number exists in the url we need to read it
    this.myForm1.get("caseNumber").setValue(this.route.snapshot.queryParamMap.get('casenumber'));

    this.caseDetails = new CaseDetails();
    this.arrAttachments = new Array();
    //this.geturl();
  }

async geturl(){
  this.Url = this.dataservice.arrTranslations[0].APIContactusURL;//"https://localhost:44354/api/Contactus";
}

  onSubmit1(form1: FormGroup) {
    //console.log('Valid?', form1.valid); // true or false
    //console.log('Name', form1.value.firstName);
    //alert();
    if (!form1.valid)
      return;

    this.caseDetails.SRNumber = form1.get("caseNumber").value;
    this.caseDetails.LastName = form1.get("lastName").value.toUpperCase();
    this.caseDetails.ContactEmail = form1.get("email").value.toUpperCase();

    this.searchCase();

    this.myForm2 = this.fb.group({
      casenumber2: [{value: '', disabled:true}, [Validators.required, Validators.pattern('^[0-9]*$')]],
      email: [{ value: '', disabled: true }, [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[A-Za-z]{2,4}$')]],
      newcomments: [{ value: '', disabled: false }, [Validators.required, Validators.pattern('(.|\n)*?')]],
      description: [{ value: '', disabled: true }],
      vin: [{ value: '', disabled: true }, [Validators.pattern('[A-Za-z ]{1,32}')]],
      model: [{ value: '', disabled: true }, [Validators.pattern('[A-Za-z ]{1,32}')]],
      year: [{ value: '', disabled: true }, [Validators.pattern('^[0-9]*$')]],
      files: new FormArray([])
    });
  

    //this.showPage1 = false;
    //this.showPage3 = false;
    //this.showPage2 = true;


  }

  private CaseDetails: CaseDetails;
  myCase: Case;
  Error: Boolean = false;
  CaseNotFound: Boolean = false;
  searchCase(): void {
    this.ShowSpinner = true;
    this.mode = 'indeterminate';
    this.CaseNotFound = false;

    this.myCase = new Case();
    this.myCase.CaseDetails = this.caseDetails;

    this.srv.postSearchData(this.Url + '/searchcase', this.myCase).subscribe((res: Case) => {

      this.mode = 'determinate';
      if (res.CaseDetails.Operation == "Update") {
        this.CaseDetails = res.CaseDetails;
        this.Error = false;
        //alert(res.CaseDetails.Operation);
        this.myForm2.get("vin").setValue(this.CaseDetails.VIN);
        this.myForm2.get("model").setValue(this.CaseDetails.Model);
        this.myForm2.get("year").setValue(this.CaseDetails.ModelYear);

        var sTempNotesDate: String = "";
        var sTempNotesDescription: String = "";
        //alert(this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[0].NoteCreated.toString());
        /**for (let i = 0; i < this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes.length; i++) {
          if (typeof this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteCreated != 'undefined')
            sTempNotesDate = this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteCreated + sTempNotesDate;

          if (typeof this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteDescription != 'undefined')
            sTempNotesDescription = sTempNotesDate + ": " + this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteDescription + sTempNotesDescription;
        }**/

        for (let i = 0; i < this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes.length; i++) {
            if (typeof this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteCreated != 'undefined' && typeof this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteDescription != 'undefined')
            {
              sTempNotesDate = sTempNotesDate + this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteCreated + ' - ' + this.CaseDetails.ListOfFinServiceRequestNotes.FinServiceRequestNotes[i].NoteDescription + '\r\n' + '\r\n';
        
              
            }
        }

        this.myForm2.get("description").setValue(sTempNotesDate);
        this.myForm2.get("email").setValue(this.CaseDetails.ContactEmail);
        this.myForm2.get("casenumber2").setValue(this.CaseDetails.SRNumber);

        this.CaseNotFound = false;
        this.showPage1 = false;
        this.showPage2 = true;
        this.ShowSpinner = false;
      } else {
        //alert();
        this.CaseNotFound = true;
        this.showPage2 = false;
        this.showPage1 = true;
        this.ShowSpinner = false;
      }
    }, error => { this.Error = true; this.showPage2 = false; this.showPage1 = true; });
   
  }

  ClearFields(formWhatever: FormGroup) {
    formWhatever.reset();
    
  }

 ClearFieldsFiles(formWhatever: FormGroup) {
    //formWhatever.reset();
    this.myForm2.get("comments").reset();

    for (var i = 0; i < this.t.controls.length; i++) {
      this.arrAttachmentsObj = new ArrAttachmentsDetails();
      this.t.controls[i].get("filename").reset();
      this.t.controls[i].get("description").reset();
      this.t.controls[i].get("todaysdate").reset();
    }
  }

  GotoStep1(event: any) {
    this.showPage1 = true;
    this.showPage2 = false;
    this.showPage3 = false;

  }

  onSubmit2(form2: FormGroup) {
    //console.log('Valid?', form2.valid); // true or false

    if (!form2.valid)
      return;

    this.caseDetails.Description = encodeURI(form2.get("newcomments").value);
    this.caseDetails.Operation = "Update";

    //here we need to make a post webapi call to kcicontactus controller.
    //this.getPosts();


    this.showPage1 = false;
    this.showPage2 = false;
    this.showPage3 = false;
   
    if (this.arrAttachments.length <= 0)
      this.updateCase();
    else
      this.uploadFiles();

  }

  
  updateCase(): void {

    this.myCase = new Case();
    this.myCase.CaseDetails = this.caseDetails;
    this.ShowSpinner = true;

    for (var i = 0; i < this.t.controls.length; i++) {
          for (var j = 0; j < this.arrAttachments.length; j++) {
               
              if(this.arrAttachments[j].FileName == this.t.controls[i].get("filename").value){
                this.arrAttachments[j].AttDescription = this.t.controls[i].get("description").value;
                
              }
          }
    }


    this.myCase.CaseDetails.AttachmentsDetails = this.arrAttachments;
    this.srv.postData(this.Url + '/createcase', this.myCase).subscribe((res: Results) => {
      //this.posts = res;
      //alert(res.success);
      this.mode = 'determinate';
      if (res.success == "0") {
        //this.CompleteCaseUpdate();
        this.Error = false;
        this.showPage2 = false;
        this.showPage3 = true;
        this.ShowSpinner = false;
      } else {
        this.Error = true;
        this.showPage3 = false;
        this.showPage2 = true;
        this.ShowSpinner = false;
      }
    }, error => { this.Error = true; this.showPage3 = false; this.showPage2 = true; });

  }

  DeleteFile($event, fileId: String, fileName: String, myForm: any) {
    //alert(JSON.stringify(this.myForm3.value, null, 4));
    //this.uploadFiles();

    this.t.removeAt(+fileId);
    $event.preventDefault();
    this.fileCounter = +this.fileCounter - 1;
    this.isDelete = "true";
    //for (let i = 0; i < this.arrAttachments.length; i++) {
    //  if (this.arrAttachments[i].FileId == fileId) {
    //    this.arrAttachments.splice(+fileId - 1, 1);
    //    break;
    //  }
    //}

    this.arrAttachments = this.arrAttachments.filter(item => item.FileName != fileName);
    //console.log(this.arrAttachments.length);

    const formData2: FormData = new FormData();

    for (let i = 0; i < this.arrAttachments.length; i++) {
      //if (this.formData.get(this.arrAttachments[i].FileName.toString()) != null)
      formData2.append(this.arrAttachments[i].FileName.toString(), this.formData.get(this.arrAttachments[i].FileName.toString()));
      //console.log(this.arrAttachments[i].FileName.toString());
    }

    //formData2.forEach((value, key) => {
    //  console.log(key + value)
    //});

    this.formData = new FormData();
    this.formData = formData2;
  }

  arrAttachmentsObj: ArrAttachmentsDetails;
  fileCounter: Number = 0;
  validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'pdf') {
      return true;
    }
    else {
      return false;
    }
  }

  getFormattedTime() {
    var today = new Date();
    var y = today.getFullYear();
    // JavaScript months are 0-based.
    var m = today.getMonth() + 1;
    var d = today.getDate();
    var h = today.getHours();
    var mi = today.getMinutes();
    var s = today.getSeconds();
    return y + "-" + m + "-" + d + "-" + h + "-" + mi + "-" + s;
  }

  selectedFiles: FileList;
  filesToUpload: Array<File> = [];

  get f() { return this.myForm2.controls; }
  get t() { return this.f.files as FormArray; }
 


  FileUpload(event: any, myForm: any) {

    this.selectedFiles = event.target.files;

    for (let ii = 0; ii < this.selectedFiles.length; ii++) {

      if (!this.validateFile(this.selectedFiles[ii].name)) {
        this.validFile = false;
        return false;
      }

      this.validFile = true;

      this.fileCounter = +this.fileCounter + 1;
      //alert(this.selectedFiles[0].name);

      this.t.push(this.fb.group({
        filename: [{ value: '', disabled: true }],
        description: [{ value: '', enabled: true }, [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ0-9 ]{1,32}'), Validators.maxLength(17)]],
        todaysdate: [{ value: '', disabled: true }]

      }));

      var tempFileName: String[];
      tempFileName = this.selectedFiles[ii].name.split('.');
      var finalFileName: String = tempFileName[0] + "_" + this.getFormattedTime() + "." + tempFileName[1];
      //console.log(finalFileName);

      this.arrAttachmentsObj = new ArrAttachmentsDetails();
      this.arrAttachmentsObj.FileId = this.fileCounter.toString();
      this.arrAttachmentsObj.FileName = finalFileName;
      this.arrAttachmentsObj.TodaysDate = new Date().toISOString().slice(0, 10).toString();
      this.arrAttachments.push(this.arrAttachmentsObj);

      //Object.defineProperty(this.selectedFiles[ii], 'name', {
      //  writable: true,
      //  value: finalFileName
      //});

      //this.filesToUpload.push(this.selectedFiles[ii]);

      this.formData.append(finalFileName.toString(), this.selectedFiles[ii], finalFileName.toString());

      for (var i = 0; i < this.t.controls.length; i++) {
        //this.myFiles.push(e.target.files[i]);
        if (this.t.controls[i].get("description").value.toString().indexOf('object') > -1) {
          this.t.controls[i].get("filename").setValue(finalFileName);
        }
        else
          this.t.controls[i].get("filename").setValue(this.t.controls[i].get("filename").value);
        //alert(this.t.controls[i].get("description"));
        //this.t.controls[i].get("description").setValue('');
        if (this.t.controls[i].get("description").value.toString().indexOf('object') > -1) {
          this.t.controls[i].get("description").setValue('');
        }
        else {
          this.t.controls[i].get("description").setValue(this.t.controls[i].get("description").value);
          if (this.t.controls[i].get("description").valid == true)
            this.myForm2.markAsPristine();
        }

        this.t.controls[i].get("todaysdate").setValue(new Date().toISOString().slice(0, 10).toString());
      }
    }

  }

  isDelete: String = "";
  validFile: Boolean;
  formData: FormData = new FormData();
  uploadFiles() {
    //const formData: FormData = new FormData();
    const files: Array<File> = this.filesToUpload;

    //for (let i = 0; i < files.length; i++) {
    //  var tempFileName = this.arrAttachments[i];
    //  //formData.append("files[]", files[i], files[i]['name']);

    //  //var finalFileName: String = tempFileName[0] + "_" + this.getFormattedTime() + "." + tempFileName[1];

    //  this.formData.append("files", files[i], tempFileName.toString());

    //}

    //console.log(formData.get('files'));
    //this.formData.forEach((value, key) => {
    //  console.log(key + value)
    //});


    const formData2: FormData = new FormData();

    for (let i = 0; i < this.arrAttachments.length; i++) {
      //if (this.formData.get(this.arrAttachments[i].FileName.toString()) != null)
      formData2.append("files", this.formData.get(this.arrAttachments[i].FileName.toString()));
      //console.log(this.arrAttachments[i].FileName.toString());
    }

    //if (this.isDelete != "true") {
      this.formData = new FormData();
      this.formData = formData2;
    //}

    this.srv.postFiles(this.Url + '/OnPostUploadAsync', this.formData).subscribe(
      res => {
      //alert("file upload complete");      
        if (res.results == 0)
          this.updateCase();
        else {
          //here we need to show error message to user and ask him to try again.
          this.Error = true;
        }
   
      this.mode = 'determinate';
    }, error => {
      this.Error = true;    
    });

  }
}
